import { StepId } from "@/data/content";

const totalSteps = Object.keys(StepId).length;
const countCompletedSteps = (entry) => {
  return Object.keys(StepId).filter((step) => entry.value.sectionProgress[step])
    .length;
};
/**
 * App Specific Route Mapping
 *Like
 */
const nameMapping = {
  Settings: "Questions",
  Content: "Announcements"
};

/**
 * App Specific Configurations
 */
const config = {
  // if true, the table is clickable and details can be accessed
  hasActiveEntry: true,
  // Properties in addition to the default ones to display in the table
  // extraColumnKeys: ["savedLocation"],
  evaluation: true,
  wideLayout: true
};

const MAX_SCORE = 5;

/**
 * filters and formats the entries for display in the table
 * @param {*} entries
 * @returns
 */
function tableEntries(entries) {
  // apply any filtering of entries here

  entries = evaluate(entries);
  return entries;
}

/**
 * decorates the entries with completed
 * @param {*} entries
 * @returns
 */
function evaluate2(entries) {
  entries = entries.map((entry) => {
    entry.completed = entry.value.savedLocation === MAX_SCORE;
    return entry;
  });

  return entries;
}
/**
 * decorates the entries with score, maxScore, and percent
 * @param {*} entries
 * @returns
 */
function evaluate(entries) {
  entries = entries.map((entry) => {
    entry.score = countCompletedSteps(entry);
    entry.maxScore = totalSteps;
    entry.percent = Math.round((entry.score / entry.maxScore) * 100);
    return entry;
  });

  return entries;
}

/**
 * Transforms an array of entry objects by mapping each entry to a new object
 * with specific properties: fullname, onid, value, and "Last Updated".
 *
 * @param {Array} entries - The array of entry objects to be transformed.
 * @param {string} entries[].fullname - The full name of the entry.
 * @param {string} entries[].onid - The ONID of the entry.
 * @param {any} entries[].value - The value associated with the entry.
 * @param {string} entries[].tsUpdatedLabel - The timestamp label of the last update.
 * @returns {Array} - A new array of objects with the properties: fullname, onid, value, and "Last Updated".
 */
function exportEntries(entries) {
  let mappedEntries = [...entries];

  mappedEntries = entries.map((entry) => {
    return {
      fullname: entry.fullname,
      onid: entry.onid,
      savedLocation: entry.value,
      "Last Updated": entry.tsUpdatedLabel
    };
  });

  return mappedEntries;
}

export {
  nameMapping,
  config,
  exportEntries,
  tableEntries,
  evaluate,
  evaluate2
};
